import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faImages, faTrashAlt } from '@fortawesome/pro-light-svg-icons'

import FormField from 'components/forms/FormField'
import InputSearch from 'suitTheme/InputSearch'
import Link from 'suitTheme/Link'
import SidebarModal from 'modals/sidebar/SidebarModal'
import UserProfileImage from 'suitTheme/UserProfileImage'

const mapResults = (imageLibaries, images) => {
  const results = {
    groups: [
      {
        key: 'agency',
        title: 'AGENCY',
        items: imageLibaries
          .filter(library => library.owner_type === 'Agency')
          .map((library) => {
            const image = images[library.cover_image_id] || {}
            return {
              ...library,
              iconLeft: (
                <UserProfileImage image={image} imageKey="square_url">
                  <FontAwesomeIcon icon={faImages} />
                </UserProfileImage>
              ),
              secondaryText: 'Agency Library',
              text: library.title,
              key: `ImageLibrary-${library.id}`,
            }
          }),
      },
      {
        key: 'brand',
        title: 'BRAND',
        items: imageLibaries
          .filter(library => library.owner_type === 'Brand')
          .map((library) => {
            const image = images[library.cover_image_id] || {}
            return {
              ...library,
              iconLeft: (
                <UserProfileImage image={image} imageKey="square_url">
                  <FontAwesomeIcon icon={faImages} />
                </UserProfileImage>
              ),
              secondaryText: 'Brand Library',
              text: library.title,
              key: `ImageLibrary-${library.id}`,
            }
          }),
      },
    ],
  }

  return results
}

const ImageLibrary = (props) => {
  const {
    imageSelectPayload: {
      callbacks: { selectEntity },
      images,
      selectedEntity,
    },
  } = props

  const { cover_image_id, owner_type, title } = selectedEntity
  const coverImage = images[cover_image_id] || {}

  const imageLibraries = useSelector(reduxState => Object.values(reduxState.entities.imageLibraries))

  return (
    <>
      <FormField direction="column" label="Search Libraries">
        <InputSearch
          callbacks={{ selectItem: item => selectEntity({ type: 'ImageLibrary', id: item.id }) }}
          closeOnSelect
          placeholder="Search by name"
          results={mapResults(imageLibraries, images)}
          showOnFocus
        />
      </FormField>

      {!!selectedEntity.id && (
        <SidebarModal.Campaign
          boxProps={{ borderBottom: '1px dashed', borderColor: 'lineColor' }}
          disableHover
          imageUrl={coverImage.square_url}
          subtitle={`${owner_type} Library`}
          title={title}
        >
          <Link
            greyLink
            onClick={() => selectEntity({ type: 'ImageLibrary', id: 0 })}
            textProps={{ fontSize: 'small' }}
          >
            <FontAwesomeIcon icon={faTrashAlt} />
          </Link>
        </SidebarModal.Campaign>
      )}
    </>
  )
}

ImageLibrary.propTypes = {
  imageSelectPayload: PropTypes.shape({
    callbacks: PropTypes.shape({
      selectEntity: PropTypes.func.isRequired,
    }).isRequired,
    images: PropTypes.object.isRequired,
    selectedEntity: PropTypes.object.isRequired,
  }).isRequired,
}

export default ImageLibrary
